import { useState } from "react";
import { Bot, CheckCheck, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

// Aviso en los cursos que creó el agente recepcionista hasta que el gestor
// confirma que los datos están bien.
export const AgentCheckBar = ({ courseId, onChecked }) => {
  const [busy, setBusy] = useState(false);
  const click = async () => {
    setBusy(true);
    await onChecked(courseId);
    setBusy(false);
  };
  return (
    <div
      className="mb-3 flex flex-wrap items-center justify-between gap-2 rounded-md border border-violet-300 bg-white/70 px-3 py-2"
      data-testid={`course-agent-bar-${courseId}`}
    >
      <p className="flex items-center gap-2 text-xs font-semibold text-violet-900">
        <Bot className="h-4 w-4 shrink-0" />
        Creado por el agente recepcionista: comprueba que los datos están bien.
      </p>
      <Button
        size="sm"
        onClick={click}
        disabled={busy}
        className="h-8 bg-violet-700 text-xs font-semibold text-white hover:bg-violet-800"
        data-testid={`course-agent-checked-${courseId}`}
      >
        {busy ? <Loader2 className="mr-1.5 h-3.5 w-3.5 animate-spin" /> : <CheckCheck className="mr-1.5 h-3.5 w-3.5" />}
        Comprobado
      </Button>
    </div>
  );
};

export default AgentCheckBar;
